import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';

export const ModalWrapper = styled.form`
  position: ${({ isRelative }) => (isRelative ? 'relative' : 'unset')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 1096px;
  max-height: 658px;
  overflow-y: ${({ isRelative }) => (isRelative ? 'hidden' : 'auto')};
  background: ${COLORS.white};
  border-radius: 12px;
  padding: ${({ isRelative }) => (isRelative ? '33px 55px' : '32px 33px')};

  @media only screen and ${BREAKPOINTS.laptop} {
    max-height: 500px;
  }
`;

export const ModalTitleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ModalTitle = styled.span`
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular}
  color: ${COLORS.black};
`;

export const UserName = styled.span`
  ${FONTS.font16};
  ${FONT_FAMILY.FontBold};
  color: ${COLORS.mainColor};
`;

export const RequestDateAndCloseIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
`;

export const RequestDate = styled.span`
  ${FONTS.font14};
  ${FONT_FAMILY.FontRegular}
  color: ${COLORS.black};
`;

export const CloseIcon = styled.img`
  position: absolute;
  width: 16px;
  height: 16px;
  cursor: pointer;
  left: 1034px;
  bottom: 28px;
`;

export const CloseModalIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-right: 8px;
`;

export const ModalTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 5px;
  background: ${COLORS.silverShadow};
`;

export const ModalTableBody = styled.tbody``;

export const ModalTableRow = styled.tr`
  background: ${({ isHeader }) =>
    isHeader ? COLORS.mainColor : COLORS.ultralightGray};
  border: 1px solid ${COLORS.black};
  position: ${({ isHeader }) => (isHeader ? 'relative' : 'unset')};
  top: ${({ isHeader }) => (isHeader ? '-5px' : 'unset')};
`;

export const ModalTableCell = styled.td`
  width: ${({ isAnswer }) => isAnswer && '410px'};
  color: ${({ isHeader }) => (isHeader ? COLORS.white : COLORS.black)};
  text-align: start;
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  vertical-align: top;
  padding: 12px;
`;

export const CreateOfferButton = styled.button`
  align-self: end;
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px;
`;
